import { Component, Vue, Mixins } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';

@Component({
    components: AllComponents(),
})
export default class HowTo extends Mixins(CommonView) {

}
